/* 套餐列表通用方法
 * 跳转套餐详情
 *
 */
export const packageMixin = {
  methods: {
    linkPackage (item) {
      // url带机构ID或者只有一家机构时直接跳套餐详情页面，否则跳机构选择页面
      if (this.$route.query.org_id || item.org_supplier_cnt == 1 || this.isWuBa) {
        this.$router.push({
          name: 'package-detail-v2',
          params: { id: this.isWuBa?item.id:item.package_id },
          query: {
            package_name: item.package_name,
            showOthers: 0,
            channel: item.channel_code
          }
        })
      } else {
        let query = {
          package_name: item.package_name,
          channel: item.channel_code
        }
        if (item.isGroup) {
          query.group_buy_list = '1'
        }
        if (item.discount) {
          query.discount = item.discount
        }
        if (item.coupon_id) {
          query.coupon_id = item.coupon_id
        }
        this.$router.push({
          name: 'package-org-v2',
          query
        })
      }
    }
  }
}
// export default packageMixin
